interface Run {
  score: number;
}

interface Props {
  runs: Run[];
  color: string;
  w?: number;
  h?: number;
}

export function Spark({ runs, color, w = 96, h = 34 }: Props) {
  if (runs.length < 2) {
    return <svg width={w} height={h} viewBox={`0 0 ${w} ${h}`} className="spark" />;
  }
  const scores = runs.map((r) => r.score);
  const min = Math.min(...scores) - 6;
  const max = Math.max(...scores) + 6;
  const span = Math.max(1, max - min);
  const pts: [number, number][] = scores.map((s, i) => {
    const x = (i / (scores.length - 1)) * w;
    const y = h - ((s - min) / span) * h;
    return [x, y];
  });
  const d = pts.map((p, i) => `${i ? "L" : "M"}${p[0].toFixed(1)} ${p[1].toFixed(1)}`).join(" ");
  const last = pts[pts.length - 1];
  return (
    <svg width={w} height={h} viewBox={`0 0 ${w} ${h}`} className="spark">
      <path d={d} fill="none" stroke={color} strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" />
      <circle cx={last[0]} cy={last[1]} r="3.5" fill={color} stroke="var(--ink)" strokeWidth="1.5" />
    </svg>
  );
}
